import { HTMLAttributes } from "react";

import Image from "next/image";

import bearOff from "@/app/assets/bear_off.png";
import bearOn from "@/app/assets/bear_on.png";
import bearOnViolet from "@/app/assets/illustration/5 your sleep journey/webp/baby bear hi.webp";
import bearOffViolet from "@/app/assets/illustration/5 your sleep journey/webp/baby bear sleep.webp";

interface BearIconProps extends HTMLAttributes<HTMLDivElement> {
    size?: number;
    variant?: "default" | "violet";
}

const iconStyle = {
    display: "inline-block",
    maxHeight: "36px",
    maxWidth: "36px",
    position: "relative",
    width: "100%",
};

export function BearOn({ size = 24, variant = "default", ...props }: BearIconProps) {
    return (
        <div style={iconStyle as any} {...props}>
            <Image
                alt="Bear On"
                fill
                src={variant === "violet" ? bearOnViolet : bearOn}
                style={{ objectFit: "contain" }}
            />
        </div>
    );
}

export function BearOff({ size = 24, variant = "default", ...props }: BearIconProps) {
    return (
        <div style={iconStyle as any} {...props}>
            <Image
                alt="Bear Off"
                fill
                src={variant === "violet" ? bearOffViolet : bearOff}
                style={{ objectFit: "contain" }}
            />
        </div>
    );
}
